import Vue from 'vue'

export interface StateProps<Type> {
  stateName: string;
  data: Type;
}

type SetState = <Type>(state: Utils.Object, { stateName, data }: StateProps<Type>) => void;

export const setState: SetState = (state, { stateName, data }) => {
  if (!stateName) { throw new Error('Please provide correct state name') }

  const nameSpace = stateName.split('.')
  const lastItem = nameSpace[nameSpace.length - 1]

  nameSpace.splice(nameSpace.length - 1, 1)

  Vue.set(nameSpace.reduce((acc, domain) => acc[domain], state), lastItem, data)
}

export const convertToSentListCard = (listCard, application) => {
  return {
    expirationDate: listCard.expirationDate,
    amount: listCard.amount,
    dateApplied: new Date().toISOString(),
    dateAppliedWithoutTimezone: new Date().toISOString(),
    derivedStatus: 'SENT' as Scholarship.DerivedStatus,
    scholarshipId: listCard.scholarshipId,
    scholarshipType: listCard.scholarshipType,
    title: listCard.title,
    wonAt: null,
    awards: listCard.awards,
    amountsList: [...listCard.amountsList],
    winnerAnnouncementDate: application.winnerAnnouncementDate,
    payoutMethod: listCard.payoutMethod
  }
}

export interface GoalData {
  data: {
    attributes: {
      payload: string
    },
    relationships: {
      requirement: {
        data: {
          id: number,
          type: string
        }
      }
    }
  }
}

export const goalData = (payload, reqId) => {
  return {
    data: {
      attributes: {
        payload
      },
      relationships: {
        requirement: {
          data: {
            id: reqId,
            type: 'requirementGoal'
          }
        }
      }
    }
  }
}

export const toFormData = (obj, form?, namespace?) => {
  const fd = form || new FormData()
  let formKey

  for (const property in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(property) && obj[property]) {
      if (namespace) {
        formKey = namespace + '[' + property + ']'
      } else {
        formKey = property
      }

      // if the property is an object, but not a File, use recursivity.
      if (obj[property] instanceof Date) {
        fd.append(formKey, obj[property].toISOString())
      } else if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
        toFormData(obj[property], fd, formKey)
      } else { // if it's a string or a File object
        fd.append(formKey, obj[property])
      }
    }
  }

  return fd
}
